import React from 'react';

const TennisPrograms = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr></hr>
                        <h2 className="intro-text text-center">Teniska radionica</h2>
                        <hr></hr>
                        <hr className="visible-xs"></hr>
                        <p>Ovaj program je za naše najmlađe članove (5-8godina), gdje se upoznavaju s prvim oblicima grupnog treniranja, upotrebom prilagođenih teniskih rekvizita za njihovu dob (manji reketi, mekane loptice, te dodatni rekviziti). Cilj je razviti motoričke sposobnosti (kooordinacija, brzina) kroz igru i zabavu, kako bi zavoljeli tenis i igrali ga što duže vrijeme.</p>
                    </div>
                </div>
            </div>
            
            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr></hr>
                        <h2 className="intro-text text-center">Tennis 10's</h2>
                        <hr></hr>
                        <hr className="visible-xs"></hr>
                        <p>Program je verificiran od ITF-a (Internacionalna teniska federacija), koji ima za cilj omasovljenje i promociju tenisa u cijelom svijetu. Teniski klub Vamos sa svojim licenciranim trenerima će provoditi ovaj program za djecu ispod 10 godina. </p>
                        <p> Prednosti ovog programa su: </p>
                            <ol>
                                <li>Tenis je lakši kada se koriste sporije crvene, naranđaste i zelene loptice.</li>
                                <li>Tenis je zabavniji kada djeca serviraju i igraju za bodove od samoga početka</li>
                                <li>Teniska natjecanja su zabavnija kada format i bodovni sustav natjecanja odgovaraju svim životnim sitlovima</li>
                                <li>Tenis je zdrav kada se koriste navedene karakteristike programa. Mnoga istraživanja su to dokazala.</li>
                                <li>Tenis je sport za sve ( od 6. do 66. godine ☺ )</li>
                            </ol>
                    
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr></hr>
                        <h2 className="intro-text text-center">Tenis za natjecatelje</h2>
                        <hr></hr>
                        <hr className="visible-xs"></hr>
                        <p>Ovaj program nudi planiranje i programiranje, te kontrolu treniranosti tenisača u svrhu razvijanja natjecateljskih sposobnosti i znanja. Nakon određenog perioda sustavnog treniranja, igrač se može odlučiti za natjecateljski tenis, kada je potrebno više predanost i rada tenisača, napora roditelja, veća uključenost trenera kako bi zajedno ostvarili jedan cilj – svaki dan biti bolji od prošloga. Natjecatelji mogu koristiti ovaj program od 12. godine. Nudimo praćenje na turnire u Hrvatskoj i u inozemstvu.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr></hr>
                        <h2 className="intro-text text-center">Tennis Xpress – za odrasle</h2>
                        <hr></hr>
                        <hr className="visible-xs"></hr>
                        <p>Ovaj program nudi zabavu, zdravu rekreaciju i ugodno druženje kroz tenisku igru. Ukoliko ste cijeli dan na poslu i treba vam tjelesna aktivnost, tenis Xpress će Vam uljepšati ostatak dana. Sportska druženja su najzabavnija druženja, a na našim terenima Vam želimo osigurati tu dobru atmosferu i da se ugodno osjećate. Nudimo savjetovanje u izboru opreme za tenis, pronalaženje sparing partnera i organiziranje rekreativne klupske lige.</p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="box">
                    <div className="col-lg-12">
                        <hr></hr>
                        <h2 className="intro-text text-center">Tenis za poduzeća</h2>
                        <hr></hr>
                        <hr className="visible-xs"></hr>
                        <p>Ovaj program nudi popularni teambuilding. Za sva poduzeća koja žele potaknuti među svojim zaposlenicima bolju komunikaciju, timski duh i efikasnije djelovanje posjetite naše teniske terene gdje ćemo Vam osigurati ugodan osjećaj uz pratnju naših trenera. Kafić preko puta kluba će osigurati dodatno druženje uz koje piće.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TennisPrograms



// WEBPACK FOOTER //
// ./src/components/TennisPrograms.js